export default "__VITE_ASSET__$oGZYNRX__"